import React, { useEffect, useMemo } from 'react';
import { TransfersTable } from './components';
import { AsyncBoundary } from '../../../components/AsyncBoundary';
import { TransferOrder } from './transfersTypes';
import { useStockTransfersStore } from '../../../store/stockTransfersStore';
import { StockTransfer } from '../../../services/stockTransfersApi';
import styles from './WarehouseTransfers.module.css';

function adapt(t: StockTransfer): TransferOrder {
  return {
    id: String(t.id),
    transferId: t.transfer_number,
    fromWarehouse: t.source_location,
    toWarehouse: t.destination_location,
    date: new Date(t.requested_at).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' }).toUpperCase(),
    status: t.status === 'pending' ? 'Pending' : t.status === 'in_transit' ? 'Dispatched' : 'Packed',
  };
}

const WarehouseTransfers: React.FC = () => {
  const items = useStockTransfersStore((s) => s.items);
  const loading = useStockTransfersStore((s) => s.loading);
  const error = useStockTransfersStore((s) => s.error);
  const fetchList = useStockTransfersStore((s) => s.fetchList);
  const setStatus = useStockTransfersStore((s) => s.setStatus);

  useEffect(() => { fetchList(); }, [fetchList]);

  const orders = useMemo<TransferOrder[]>(() => items.map(adapt), [items]);

  const handleAction = async (id: string, action: string) => {
    if (action === 'dispatch') await setStatus(id, 'in_transit');
    else if (action === 'complete') await setStatus(id, 'completed');
    else if (action === 'cancel') await setStatus(id, 'cancelled');
  };

  return (
    <div className={styles.container}>
      <AsyncBoundary
        loading={loading && items.length === 0}
        error={error}
        empty={!loading && orders.length === 0}
        emptyMessage="No transfers to display"
        onRetry={() => fetchList()}
      >
        <TransfersTable orders={orders} onAction={handleAction} />
      </AsyncBoundary>
    </div>
  );
};

export const WarehouseTransfersPage: React.FC = () => <WarehouseTransfers />;
export default WarehouseTransfers;
